import { create } from 'zustand'
import { getDocuments } from '@/services/documents'

interface PendingReviewState {
  /** Count of documents awaiting review (status = pending_review). Null until first fetch resolves. */
  count: number | null
  fetchCount: () => Promise<void>
  setCount: (count: number) => void
  adjustCount: (delta: number) => void
}

export const usePendingReviewStore = create<PendingReviewState>((set) => ({
  count: null,

  fetchCount: async () => {
    try {
      const { total } = await getDocuments({ status: 'pending_review', page: 1, page_size: 1 })
      set({ count: total })
    } catch (e) {
      console.error('Failed to fetch pending review count:', e)
    }
  },

  setCount: (count) => set({ count }),

  adjustCount: (delta) =>
    set((state) => ({
      count: state.count == null ? state.count : Math.max(0, state.count + delta),
    })),
}))
